import { firestore } from 'firebase';
import _ from 'lodash';
import DatabaseAdapter from 'src/firebase/db/DatabaseAdapter';
import { ReferenceError, InternalError } from 'src/firebase/db/ApplicationError';

const notificationItemIntitialEntity = {
  title: '',
  body: '',
  zendesk_url: '',
  is_read: false,
  ref: undefined,
  send_at: {} as firestore.Timestamp,
  created_at: {} as firestore.Timestamp,
};

export type NotificationItemEntity = typeof notificationItemIntitialEntity;

export const notificationsInitialEntity = {
  unread_system_count: 0,
  unread_baked_count: 0,
  item: [] as NotificationItemEntity[],
};

export type NotificationsEntity = typeof notificationsInitialEntity;

export const userInitialEntity = {
  name: '',
  birthday: '',
  email: '',
  user_id: '',
  image: '',
  postalCode1: '',
  postalCode2: '',
  state: '',
  gender: 'noset',
  city: '',
  street: '',
  building: '',
  orders: [] as firestore.DocumentReference[],
  created_at: {} as firestore.FieldValue,
  updated_at: {} as firestore.FieldValue,
  baked_breads: [] as firestore.DocumentReference[],
  baked_breads_disabled: [] as firestore.DocumentReference[],
  notifications: {
    unread_system_count: 0,
    unread_baked_count: 0,
    item: [],
  } as NotificationsEntity,
  permission: {
    accept_from_sacri: false,
    accept_baked_bread: false,
    notification_token: '',
  },
};

export type UserEntity = typeof userInitialEntity;

export const userEntityKeys = (Object.keys(userInitialEntity) as unknown) as (keyof UserEntity)[];

class UsersDB extends DatabaseAdapter {
  constructor(props: any) {
    super(props);
    this.setSchemaKeys(userEntityKeys);
  }

  getRegisterdBakedBreadsUserCount = async (bakedBreadDocId: string) => {
    const bakedBreadsDocRef = this.getConnection('baked_breads').doc(bakedBreadDocId);
    return this.getConnection()
      .where('baked_breads', 'array-contains', bakedBreadsDocRef)
      .get()
      .then((snap) => {
        return snap.size;
      })
      .catch((e) => {
        console.log(e);
        return 0;
      });
  };

  // ユーザーを一覧で取得する
  getUsers = async (uids: string[]) => {
    // in演算子は10件を超えるとクラッシュするので、分割して取得する
    const chunks = _.chunk(uids, 10);

    const records = await Promise.all(
      chunks.map(
        async (chunk) =>
          await this.getConnection()
            .where('user_id', 'in', chunk)
            .get()
            .then(async (snapshot) => {
              if (snapshot.empty) {
                throw new ReferenceError('ユーザーが存在しません');
              }
              return await Promise.all(snapshot.docs.map(async (doc) => doc.data() as UserEntity));
            })
            .catch((e) => {
              console.error(e);
              if (e instanceof ReferenceError) {
                throw e;
              }
              throw new InternalError(e.message);
            }),
      ),
    );

    const users = _(records).flatten().value();
    return this.formatSuccess<UserEntity[]>(users);
  };
}

export default new UsersDB({
  schema: 'users',
});
